// Run this once to create a test user in Firestore
// You can run this from browser console or create a temporary button

import { collection, addDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';

export const createTestUser = async () => {
  try {
    const testUser = {
      username: 'testuser',
      password: 'test123',
      email: 'testuser@example.com',
      name: 'Test User',
      active: true,
      createdAt: new Date().toISOString()
    };
    
    const docRef = await addDoc(collection(db, 'users'), testUser);
    console.log('Test user created with ID:', docRef.id);
    console.log('Login credentials:');
    console.log('  Username: testuser');
    console.log('  Password: test123');
    return docRef.id;
  } catch (error) {
    console.error('Error creating test user:', error);
    throw error;
  }
};
